import styled from 'styled-components';

interface ScrollContainerProps {
    gap?: string;
}
export const ScrollContainerWrapper = styled.div<ScrollContainerProps>`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow-y: auto;
    scrollbar-width: none;
    gap: ${({ gap }) => gap || '0px'};
`;
